<template>
  <div class="lg:px-12 md:px-12 px-5 lg:py-8 md:py-10 py-8 bg-f3">
    <div class="container mx-auto">
      <div class="lg:w-2/3 mx-auto text-center">
        <h2 class="font-semibold text4F0A4B fsize32 sm-fsize24 mb-8">
          Reference Websites and Partner Organizations
        </h2>
      </div>
      <div class="mt-6">
        <div class="lg:mt-6 md:mt-5 mt-4 lg:w-9/12 mx-auto">
          <swiper class="swiper" :options="swiperOptions">
            <swiper-slide
              v-for="(item, index) in campaignReference.data"
              :key="index"
            >
              <div class="bg-fff p-3 rounded-lg">
                <img
                  :src="`${$imageURL}/${item.image}`"
                  alt="india"
                  class="h-280px w-full object-cover rounded-lg"
                />
                <img />
                <div class="text-left">
                  <h2 class="uppercase clr-black fsize16 font-semibold pt-4">
                    {{ item.title }}
                  </h2>
                  <p class="fsize14 font-normal text-gray">
                    {{ item.description }}
                  </p>
                  <a :href="item.link" target="blank">
                    <div class="text-primary flex gap-1 items-center mt-2">
                      <p class="">Go to Website</p>
                      <feather-icon
                        icon="ArrowUpRightIcon"
                        class="cursor-pointer"
                        svgClasses="w-4 h-4"
                      ></feather-icon>
                    </div>
                  </a>
                </div>
              </div>
            </swiper-slide>

            <div
              class="swiper-button-prev adminswiper"
              slot="button-prev"
            ></div>
            <div
              class="swiper-button-next adminswiper"
              slot="button-next"
            ></div>
          </swiper>
        </div>
      </div>
      <!-- <div class="mt-10">
        <p class="text-center font-semibold text4F0A4B fsize24 sm-fsize24 mb-2">
          FOR GLOBAL
        </p>
        <div class="lg:mt-6 md:mt-5 mt-4 lg:w-11/12 mx-auto">
          <swiper class="swiper" :options="swiperOptions2">
            <swiper-slide v-for="(item, index) in globalData" :key="index">
              <div class="bg-fff p-3 rounded-lg">
                <img
                  v-if="item.location === 'Global' && item.picture"
                  :src="`${$imageURL}/${item.picture}`"
                  alt="india"
                  class="h-200 w-full object-cover rounded-lg"
                />
                <img
                  v-else
                  src="https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg"
                  alt="india"
                  class="h-200 w-full object-cover rounded-lg"
                />
                <div class="text-left">
                  <h2
                    class="uppercase clr-black fsize16 font-semibold pt-4"
                  >
                    {{ item.title }}
                  </h2>
                  <p class="fsize14 font-normal text-gray">
                    {{ item.description }}
                  </p>
                  <a :href="item.link" target="blank">
                    <div class="text-primary flex gap-1 items-center mt-2">
                      <p class="">Go to Website</p>
                      <feather-icon
                        icon="ArrowUpRightIcon"
                        class="cursor-pointer"
                        svgClasses="w-4 h-4"
                      ></feather-icon>
                    </div>
                  </a>
                </div>
              </div>
            </swiper-slide>

            <div
              class="swiper-button-prev adminswiper"
              slot="button-prev"
            ></div>
            <div
              class="swiper-button-next adminswiper"
              slot="button-next"
            ></div>
          </swiper>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mounted } from "@chenfengyuan/vue-countdown";
import { mapState } from "vuex/dist/vuex.common.js";
import router from "../../../routes/router";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          1600: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptions2: {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          1600: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      location: "",
    };
  },
  computed: {
    ...mapState("campaignPageBanner", {
      campaignReference: "campaignReference",
    }),
  },
  methods: {
    async goToWebsite(link) {
      router.push(link, "_blank");
    },

    async init() {
      await this.$store.dispatch("campaignPageBanner/get_campaignreference");
    },
  },
  async mounted() {
    this.init();
    console.log("campaignReference", this.campaignReference);
  },
};
</script>

<style></style>
